// required for zod type safety with `Result.wrap`
export class EmptyResultError extends Error {}
